/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 预览模块路由
 */

import Layout from '@/layout/index.vue'
import { RouteConfig } from 'vue-router/types/router'

import RichText from '@/views/preview/rich_text.vue'

const previewRoute: RouteConfig = {
    path: '/preview',
    component: Layout,
    meta: {
        hidden: true
    },
    children: [
        {
            path: 'rich-text',
            component: RichText,
            name: 'RichText',
            meta: {
                title: '预览模块'
            }
        }
    ]
}

export default previewRoute
